import {
	footerTruste,
	footerNorton,
	footerBBB
} from './assets/brand-assets';
export const footerData = [
    {
        name: `Products`,
        links: [{
            text: `eHealth Home`,
            url: `/`,
            'data-wa': `footer:eHealth Home`
        }, {
            text: `eHealth Medicare`,
            url: `/medicare`,
            'data-wa': `footer:eHealth Medicare`
        }, {
            text: `Individual & Family Health Insurance`,
            url: `/individual-family-health-insurance`,
            'data-wa': `footer:Individual & Family Health Insurance`
        }, {
            url: "/medicaid",
            text: "Medicaid",
            'data-wa': `footer:Medicaid`
        }, {
            url: "//www.ehealthmedicare.com/",
            text: "Medicare",
            'data-wa': `footer:Medicare`
        }, {
            url: "/small-business-health-insurance",
            text: "Small Business Health Insurance",
            'data-wa': `footer:Small Business Health Insurance`
        }, ]
    }, {
        name: `Services`,
        links: [{
                url: "/resources/affordable-care-act",
                text: "Affordable Care Act",
                'data-wa': `footer:Affordable Care Act`
            },
            {
                url: "/health-insurance-companies",
                text: "Health Insurance Companies",
                'data-wa': `footer:Health Insurance Companies`
            },
            {
                url: "//doctor.ehealthinsurance.com",
                text: "Find a Doctor",
                'data-wa': `footer:Find a Doctor`
            },
            {
                url: "/health-plans/hmo",
                text: "HMO Plans",
                'data-wa': `footer:HMO Plans`
            }, {
                url: "/affordable-health-insurance-by-state",
                text: "Medical Plans By State",
                'data-wa': `footer:Medical Plans By State`
            },
            {
                url: "/obamacare",
                text: "Obamacare Made Simple",
                'data-wa': `footer:Obamacare Made Simple`
            },
            {
                url: "/health-plans/ppo",
                text: "PPO Plans",
                'data-wa': `footer:PPO Plans`
            }
        ]
    }, {
        name: `Company`,
        links: [{
                url: "/about-ehealth-index",
                text: "About Us",
                'data-wa': `footer:About Us`
            },
            {
                url: "/about-ehealth/careers-benefit",
                text: "Careers",
                'data-wa': `footer:Careers`
            },
            {
                url: "/about-ehealth/contact-us",
                text: "Contact and Support",
                'data-wa': `footer:Contact and Support`
            }, {
                url: "//ir.ehealthinsurance.com",
                text: "Investor Relations",
                'data-wa': `footer:Investor Relations`
            },
            {
                url: "/about-ehealth/licensing",
                text: "Licensing",
                'data-wa': `footer:Licensing`
            },
            {
                url: "//news.ehealthinsurance.com",
                text: "Newsroom",
                'data-wa': `footer:Newsroom`
            },
            {
                url: "/about-ehealth/privacy-policy",
                text: "Privacy Policy",
                'data-wa': `footer:Privacy Policy`
            }, {
                url: "/about-ehealth/terms-of-use",
                text: "Terms of Use",
                'data-wa': `footer:Terms of Use`
            }
        ]
    }, {
        name: `Connect`,
        links: [{
                text: `<svg style="margin-right: 8px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 7.99874C15.9998 6.46996 15.5615 4.97325 14.737 3.68581C13.9126 2.39837 12.7365 1.37412 11.3481 0.734308C9.95962 0.0944948 8.4169 -0.134083 6.90257 0.0756348C5.38823 0.285353 3.9657 0.924583 2.80337 1.91765C1.64104 2.91072 0.787596 4.21604 0.344069 5.67907C-0.099457 7.14211 -0.114491 8.7016 0.300748 10.1729C0.715987 11.6442 1.54411 12.9658 2.68708 13.981C3.83004 14.9963 5.23999 15.6629 6.75 15.9017V10.3112H4.719V7.99874H6.75V6.23625C6.75 4.23125 7.9445 3.12374 9.7715 3.12374C10.3715 3.13207 10.9701 3.18421 11.5625 3.27974V5.24874H10.5535C10.3816 5.22591 10.2067 5.24206 10.0418 5.29599C9.87698 5.34993 9.72638 5.44027 9.60119 5.56032C9.476 5.68038 9.37943 5.82706 9.31864 5.98951C9.25784 6.15195 9.23439 6.326 9.25 6.49874V7.99874H11.469L11.114 10.3112H9.25V15.9017C11.1319 15.604 12.8458 14.6445 14.0832 13.1957C15.3206 11.7469 16.0003 9.90404 16 7.99874Z" fill="#4F4F4F"/>
                </svg>
                Facebook`,
                url: `//www.facebook.com/eHealth`,
                'data-wa': `footer:Facebook`
            },
            {
                text: `<svg style="margin-right: 8px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.3333 0H0.666667C0.266667 0 0 0.266667 0 0.666667V15.3333C0 15.7333 0.266667 16 0.666667 16H15.3333C15.7333 16 16 15.7333 16 15.3333V0.666667C16 0.266667 15.7333 0 15.3333 0ZM4.73333 13.6667H2.4V6H4.8V13.6667H4.73333ZM3.53333 4.93333C2.8 4.93333 2.13333 4.33333 2.13333 3.53333C2.13333 2.8 2.73333 2.13333 3.53333 2.13333C4.26667 2.13333 4.93333 2.73333 4.93333 3.53333C4.93333 4.33333 4.33333 4.93333 3.53333 4.93333ZM13.6667 13.6667H11.2667V9.93333C11.2667 9.06667 11.2667 7.93333 10.0667 7.93333C8.8 7.93333 8.66667 8.86667 8.66667 9.86667V13.6667H6.26667V6H8.53333V7.06667C8.86667 6.46667 9.6 5.86667 10.8 5.86667C13.2 5.86667 13.6667 7.46667 13.6667 9.53333V13.6667Z" fill="#4F4F4F"/>
                </svg>
                LinkedIn
                `,
                url: `//www.linkedin.com/company/ehealthinsurance`,
                'data-wa': `footer:LinkedIn`
            }, {
                text: `<svg style="margin-right: 8px;" width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 1.5C15.4 1.8 14.8 1.9 14.1 2C14.8 1.6 15.3 1 15.5 0.2C14.9 0.6 14.2 0.8 13.4 1C12.8 0.4 11.9 0 11 0C9.3 0 7.8 1.5 7.8 3.3C7.8 3.6 7.8 3.8 7.9 4C5.2 3.9 2.7 2.6 1.1 0.6C0.8 1.1 0.7 1.6 0.7 2.3C0.7 3.4 1.3 4.4 2.2 5C1.7 5 1.2 4.8 0.7 4.6C0.7 6.2 1.8 7.5 3.3 7.8C3 7.9 2.7 7.9 2.4 7.9C2.2 7.9 2 7.9 1.8 7.8C2.2 9.1 3.4 10.1 4.9 10.1C3.8 11 2.4 11.5 0.8 11.5C0.5 11.5 0.3 11.5 0 11.5C1.5 12.4 3.2 13 5 13C11 13 14.3 8 14.3 3.7C14.3 3.6 14.3 3.4 14.3 3.3C15 2.8 15.6 2.2 16 1.5Z" fill="#4F4F4F"/>
                </svg>
                Twitter
                `,
                url: `//twitter.com/ehealth`,
                'data-wa': `footer:Twitter`
            },
            {
                url: "//www.youtube.com/user/eHealthInsurance",
                text: `<svg style="margin-right: 8px;" width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.8 2.8C15.6 1.5 15 0.6 13.6 0.4C11.4 8.9407e-08 8 0 8 0C8 0 4.6 8.9407e-08 2.4 0.4C1 0.6 0.3 1.5 0.2 2.8C0 4.1 0 6 0 6C0 6 0 7.9 0.2 9.2C0.4 10.5 1 11.4 2.4 11.6C4.6 12 8 12 8 12C8 12 11.4 12 13.6 11.6C15 11.3 15.6 10.5 15.8 9.2C16 7.9 16 6 16 6C16 6 16 4.1 15.8 2.8ZM6 9V3L11 6L6 9Z" fill="#4F4F4F"/>
                </svg>
                Youtube
                `,
                'data-wa': `footer:Youtube`
            }
        ],
        logos: [{
            url: "//privacy.truste.com/privacy-seal/validation?rid=29c54704-1813-4238-b385-66cf1e5c6d3b",
            text: footerTruste,
            'data-wa': `footer:Truste`,
            type: 'truste'
        }, {
            url: "https://trustsealinfo.websecurity.norton.com/splash?form_file=fdf/splash.fdf&dn=www.ehealthinsurance.com&lang=en",
            text: footerNorton,
            'data-wa': `footer:Norton`
        }, {
            url: "https://www.bbb.org/us/ca/mountain-view/profile/insurance-companies/ehealthinsurance-services-inc-1216-359700",
            text: footerBBB,
            'data-wa': `footer:BBB`
        }]
    }
]